"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = exports.FormSelect = exports.Chevron = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _palette = require("../../styles/palette");
var _vars = require("../../styles/vars");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FormSelect = exports.FormSelect = _styledComponents["default"].div.withConfig({
  displayName: "styles__FormSelect",
  componentId: "sc-3lmpff-0"
})(["background:", ";border-radius:", "px;position:relative;"], _palette.commonPalette.darkerGray, function (p) {
  return _vars.borderRadius[p.device];
});
var Chevron = exports.Chevron = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'chevron-down'
}).withConfig({
  displayName: "styles__Chevron",
  componentId: "sc-3lmpff-1"
})(["pointer-events:none;position:absolute;right:1rem;top:50%;transform:translateY(-50%);"]);
var Select = exports.Select = _styledComponents["default"].select.withConfig({
  displayName: "styles__Select",
  componentId: "sc-3lmpff-2"
})(["appearance:none;background:none;border:1px solid rgba(0,0,0,0.2);border-radius:", "px;display:block;font-family:inherit;font-size:inherit;height:3rem;outline:none;padding:0 3rem 0 1rem;position:relative;width:100%;&:focus,&:hover{border-color:rgba(0,0,0,0.4);}&:focus{box-shadow:0 0 0 2px rgba(0,0,0,0.1);}&::-ms-expand{display:none;}"], function (p) {
  return _vars.borderRadius[p.device];
});
//# sourceMappingURL=styles.js.map